import { EnvironmentStatus } from 'modules/environments/interfaces';
import { Filter, ConditionOperatorsEnum } from 'utils/filters';

export const filterOptions: Filter[] = [
  {
    field: 'environment_name',
    label: 'DYNAMIC_FILTER.ENVIRONMENT_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'partner_name',
    label: 'DYNAMIC_FILTER.PARTNER_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'company_name',
    label: 'DYNAMIC_FILTER.COMPANY_NAME_KEY',
    multiple: true,
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'oci_compartment_id',
    label: 'DYNAMIC_FILTER.OCI_COMPARTMENT_ID_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'zero_trust_enabled',
    label: 'DYNAMIC_FILTER.ZERO_TRUST_ENABLED_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  { field: 'main_model_id', label: 'DYNAMIC_FILTER.MAIN_MODEL_ID_KEY' },
  { field: 'backup_model_id', label: 'DYNAMIC_FILTER.BACKUP_MODEL_ID_KEY' },
  {
    field: 'region',
    multiple: true,
    label: 'DYNAMIC_FILTER.REGION_KEY',
    defaultOperator: ConditionOperatorsEnum.ICONTAINS,
  },
  {
    field: 'block_multiple_session',
    label: 'DYNAMIC_FILTER.BLOCK_MULTIPLE_SESSION_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'use_dns',
    label: 'DYNAMIC_FILTER.USE_DNS_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'license_limit_per_client',
    label: 'DYNAMIC_FILTER.LICENSE_LIMIT_PER_CLIENT_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'true', label: 'ACTIVE_KEY' },
      { value: 'false', label: 'INACTIVE_KEY' },
    ],
  },
  {
    field: 'maintenance',
    label: 'MAINTENANCE_STATUS_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'in_maintenance', label: 'DYNAMIC_FILTER.IN_MAINTENANCE_KEY' },
      { value: 'future_maintenance', label: 'MAINTENANCE_SCHEDULED_KEY' },
      { value: 'display_warning', label: 'SHOW_ALERT_KEY' },
    ],
  },
  {
    field: 'applications_registration_mode',
    label: 'DYNAMIC_FILTER.APPLICATIONS_REGISTRATION_MODE_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'simple', label: 'DYNAMIC_FILTER.SIMPLE_KEY' },
      { value: 'advanced', label: 'DYNAMIC_FILTER.ADVANCED_KEY' },
    ],
  },
  {
    field: 'connection_type',
    label: 'DYNAMIC_FILTER.CONNECTION_TYPE_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'public', label: 'DYNAMIC_FILTER.PUBLIC_KEY' },
      { value: 'private', label: 'DYNAMIC_FILTER.PRIVATE_KEY' },
    ],
  },
  {
    field: 'provider_type',
    label: 'DYNAMIC_FILTER.PROVIDER_TYPE_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'aws', label: 'DYNAMIC_FILTER.AWS_KEY' },
      { value: 'oci', label: 'DYNAMIC_FILTER.OCI_KEY' },
      { value: 'multicloud', label: 'DYNAMIC_FILTER.MULTICLOUD_KEY' },
    ],
  },
  {
    field: 'behavior_type',
    label: 'DYNAMIC_FILTER.BEHAVIOR_TYPE_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'manual', label: 'DYNAMIC_FILTER.MANUAL_KEY' },
      { value: 'period', label: 'DYNAMIC_FILTER.PERIOD_KEY' },
      { value: 'micro', label: 'DYNAMIC_FILTER.MICRO_KEY' },
      { value: 'spot_period', label: 'DYNAMIC_FILTER.SPOT_PERIOD_KEY' },
      { value: 'haas', label: 'DYNAMIC_FILTER.HAAS_KEY' },
      { value: 'ccc', label: 'DYNAMIC_FILTER.CCC_KEY' },
    ],
  },
  {
    field: 'publication_type',
    label: 'DYNAMIC_FILTER.PUBLICATION_TYPE_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'custom_image', label: 'DYNAMIC_FILTER.CUSTOM_IMAGE_KEY' },
      { value: 'boot_volume', label: 'DYNAMIC_FILTER.BOOT_VOLUME_KEY' },
      {
        value: 'boot_volume_backup',
        label: 'DYNAMIC_FILTER.BOOT_VOLUME_BACKUP_KEY',
      },
    ],
  },
  {
    field: 'virtualizer',
    label: 'DYNAMIC_FILTER.VIRTUALIZER_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'connect', label: 'DYNAMIC_FILTER.CONNECT_KEY' },
      { value: 'connect_direct', label: 'DYNAMIC_FILTER.CONNECT_DIRECT_KEY' },
      { value: 'rdp', label: 'DYNAMIC_FILTER.RDP_KEY' },
      { value: 'rdp_direct', label: 'DYNAMIC_FILTER.RDP_DIRECT_KEY' },
      { value: 'rdp_app', label: 'DYNAMIC_FILTER.RDP_APP_KEY' },
      { value: 'tsplus', label: 'DYNAMIC_FILTER.TSPLUS_KEY' },
      {
        value: 'tsplus_remote_app',
        label: 'DYNAMIC_FILTER.TSPLUS_REMOTE_APP_KEY',
      },
      { value: 'tsplus_all', label: 'DYNAMIC_FILTER.TSPLUS_ALL_KEY' },
    ],
  },
  {
    field: 'env_status',
    label: 'ENVIRONMENT_STATUS_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      {
        value: EnvironmentStatus.DEMONSTRATION,
        label: 'ENVIRONMENT_STATUS.DEMONSTRATION_KEY',
      },
      {
        value: EnvironmentStatus.DEPLOYMENT,
        label: 'ENVIRONMENT_STATUS.DEPLOYMENT_KEY',
      },
      {
        value: EnvironmentStatus.DEVELOPMENT,
        label: 'ENVIRONMENT_STATUS.DEVELOPMENT_KEY',
      },
      {
        value: EnvironmentStatus.HOMOLOGATION,
        label: 'ENVIRONMENT_STATUS.HOMOLOGATION_KEY',
      },
      {
        value: EnvironmentStatus.MIGRATION,
        label: 'ENVIRONMENT_STATUS.MIGRATION_KEY',
      },
      {
        value: EnvironmentStatus.PRODUCTION,
        label: 'ENVIRONMENT_STATUS.PRODUCTION_KEY',
      },
      {
        value: EnvironmentStatus.PENDING,
        label: 'ENVIRONMENT_STATUS.PENDING_KEY',
      },
    ],
  },
  {
    field: 'product',
    label: 'PRODUCT_KEY',
    isSelect: true,
    selectOptions: [
      { value: 'autosky', label: 'Autosky' },
      { value: 'business_one', label: 'SAP' },
    ],
  },
  {
    field: 'product_type',
    label: 'PRODUCT_TYPE_KEY',
    multiple: true,
    isSelect: true,
    selectOptions: [
      { value: 'manual', label: 'TYPE_MANUAL_KEY' },
      { value: 'period', label: 'TYPE_ROBOT_PERIOD_KEY' },
      { value: 'spot_period', label: 'TYPE_ROBOT_PERIOD_SPOT_KEY' },
      { value: 'micro', label: 'TYPE_ROBOT_MICRO_KEY' },
      { value: 'haas', label: 'TYPE_HAAS_KEY' },
      { value: 'ccc', label: 'TYPE_CCC_KEY' },
      { value: 'dedicated', label: 'TYPE_DEDICATED_KEY' },
      { value: 'shared', label: 'TYPE_SHARED_KEY' },
    ],
  },
  { field: 'environment_uuid', label: 'DYNAMIC_FILTER.ENVIRONMENT_UUID_KEY' },
  { field: 'partner_uuid', label: 'DYNAMIC_FILTER.PARTNER_UUID_KEY' },
  { field: 'company_uuid', label: 'DYNAMIC_FILTER.COMPANY_UUID_KEY' },
];
